export const TOGGLE_EXPAND_MENU_ITEM = 'TOGGLE_EXPAND_MENU_ITEM'
export const CLOSE_MENU = 'CLOSE_MENU'
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const UPDATE_SUBMENU_OPENED = 'UPDATE_SUBMENU_OPENED'
export const HIDE_SUBMENU = 'HIDE_SUBMENU'
export const TOGGLE_WITHOUT_ANIMATION = 'TOGGLE_WITHOUT_ANIMATION'
